export const getSafePathname = (pathname: string) =>
  ['/404/', '/500/'].includes(pathname) ? '/' : pathname;
